<template>
    <div>
        <div v-if="isLoading" class="loader">
            <div class="wave-container">
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
            </div>
            <p>Loading...</p>
        </div>
        <div v-if="!isLoading">
            <div>
                <b-modal id="homeModel" v-model="showModal" ok-only @ok.prevent="saveOptInData" ok-title="submit" @hidden="onModalHidden"
                    @hide="onModalHide">
                    <template v-slot:modal-title><span v-html="content.OptinText"></span></template>
                    <b-form-group label="Email address:" label-for="email">
                        <b-form-input id="email" v-model="form.email" type="email" placeholder="Enter email"
                            :state="$v.form.email.$dirty ? !$v.form.email.$error : null"></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                            field.
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Your Phone:" label-for="phone">
                        <b-form-input id="phone" v-model="form.phone" placeholder="Enter Phone"
                            :state="$v.form.phone.$dirty ? !$v.form.phone.$error : null"></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                            field.
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-modal>
            </div>
            <div>
                <div class="top-banner">
                    <div class="pendil-img">
                        <img src="./../../assets/images/dr-banr.png" alt="Image">
                    </div>
                    <div class="banner-text">
                        <p class="signature">Message from <span>Dr. Sawyer</span></p>
                        <p v-html="content1.message"></p>
                    </div>
                </div>
            </div>
            <div class="center-content">
                <div class="row">
                    <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 left-content">
                        <div class="row bages-row">
                            <ModuleBoxVue :ModuleData="ModuleData" />
                            <ModuleBoxVue :ModuleData="weekData" />
                        </div>
                        <div class="material-box bg-white">
                            <div class="full-width">
                                <div class="col-lg-12">
                                    <div class="top-title">
                                        <h3>Materials</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="full-width">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <DocumentBox :materialData="documentsData" />
                                    <VideoBox :videoData="videosData" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 right-sidebar">
                        <seminar-sidebar :seminar-data="seminarData" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import userAPI from '../userApi'
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import ModuleBoxVue from './Components/ModuleBox.vue';
import DocumentBox from './Components/DocumentBox.vue';
import VideoBox from './Components/VideoBox.vue';
import SeminarSidebar from './Components/SeminarSidebar.vue';

export default {
    name: 'user_home',
    mixins: [validationMixin],
    data() {
        return {
            isLoading:false,
            showModal:false,
            content: {
                DrScottSawyerMessage: "",
                OptinText: ""
            },
             content1: {
                message: "",
            },
            ModuleData: {
                num: "",
                name: "",
                description: "",
                bgColor: "",
                title: "",
                id: ""
            },
            documentsData: {
                title: "",
                documents: {
                    name: "",
                    link: ""
                }
            },
            videosData: {
                title: "",
                video: {
                    name: "",
                    link: ""
                }
            },
            seminarData: {
                seminars: {
                    ModuleSmallImage: "",
                    ModuleName: "",
                    ModuleStartDate: "",
                    ModuleVenue: "",
                }
            },
            weekData: {
                num: "",
                name: "",
                description: "",
                bgColor: "",
                title: "",
                weekNumber: ""
            },
            form: {
                email: "",
                phone: "",
                clientEmail: ""
            },
        }
    },
    validations: {
        form: {
            email: {
                required, email
            },
            phone: {
                required,
            },
        }
    },
    methods: {
        onModalHide(evt) {
            // Prevent closing the modal on blur
            
                evt.preventDefault();
            
        },
        onModalHidden() {
            // Reset the modal's state
            this.showModal = true;
        },
        getUpdatedNextModule() {
            this.isLoading = true;
            userAPI.getUpdatedNextModule(res => {
                this.seminarData.seminars = res.data.data;
                this.isLoading = false;
            }, err => {
                console.log(err);
                this.isLoading = false;
            });
        },
        getScheduleVideos(params) {
            // this.isLoading = true;
            userAPI.getScheduleVideos(params, res => {
                this.videosData.title = "Videos",
                    this.videosData.video = res.data.data.map((ele) => {
                        // console.log('ele src:', ele);
                        return {
                            name: ele.VideoName,
                            link: ele.Link
                        }
                    })
            }, err => {
                console.log(err)
            });
        },
        getScheduleDocs(params) {
            userAPI.getScheduleDocs(params, res => {
                this.documentsData.title = "Documents",
                    this.documentsData.documents = res.data.data.map((ele) => {
                        return {
                            name: ele.DocName,
                            link: `${window.location.hostname == '202.141.226.195' ? '8069578_1703609074.pdf' : ele.DocLocation}`,
                        }
                    })
            }, err => {
                console.log(err)
            });
        },
        getCurrentweekByModule(moduleId) {
            userAPI.getCurrentweekByModule({ moduleId }, res => {
                this.weekData.num = res.data.data.WeekNumber;
                this.weekData.name = res.data.data.WeekName;
                this.weekData.description = res.data.data.WeekDescription;
                this.weekData.bgColor = "yellow-bag-box";
                this.weekData.title = "Week";
                this.weekData.weekNumber = res.data.data.WeekNumber;
                this.getScheduleDocs({ moduleId: this.ModuleData.id, weekNumber: this.weekData.weekNumber })
                this.getScheduleVideos({ moduleId: this.ModuleData.id, weekNumber: this.weekData.weekNumber })
            })
        },
        getCurrentModule() {
            userAPI.getCurrentModule(res => {
                this.ModuleData.num = res.data.data.ModuleNumber;
                this.ModuleData.name = res.data.data.ModuleName;
                this.ModuleData.description = res.data.data.ModuleDescription;
                this.ModuleData.bgColor = "blue-bag-box";
                this.ModuleData.title = "Module";
                this.ModuleData.id = res.data.data.ModuleID;
                this.getCurrentweekByModule(res.data.data.ModuleID);
            })
        },
        saveOptInData() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            userAPI.saveOptInData(this.form, res => {
                this.$bvModal.hide('homeModel')
            })
        },
        getOptStatus() {
            this.form.clientEmail = JSON.parse(localStorage.getItem('userDetails'))['email'];
            let email = this.form.clientEmail;
            userAPI.checkOptStatusUserByEmail({ email }, res => {
                if (res.data.data.OptStatus != 1) {
                    this.$bvModal.show('homeModel')
                }
            }, err => {
                console.log(err)
            }
            );
        },
        getWebContent() {
            userAPI.getWebContent(this.getWebContentCB, this.errorCB)
        },
        getWebContentCB(res) {
            this.content = res.data;
            this.content1 = res.data1;
        },
        errorCB(err) {
            console.log(err);
        }
    },
    mounted() {
        this.getCurrentModule()
        this.getOptStatus()
        this.getWebContent()
        this.getUpdatedNextModule()
    },
    components: {
        ModuleBoxVue,
        DocumentBox,
        VideoBox,
        SeminarSidebar
    }
}
</script>

<style>
@import './Home.css';
</style>